import {
  Table, Thead, Tbody, Tr, Th, Td, Box, Container, Flex, Tooltip,
  Select,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  IconButton, Text
} from "@chakra-ui/react"
import React from "react"
import { useTable, useExpanded, usePagination } from "react-table"
import Card from "../card/Card.js"
import CardBody from "../card/CardBody.js"
import styles from "../../styles/table.module.css"
import { useRouter } from "next/router"
import {
  ArrowRightIcon,
  ArrowLeftIcon,
  ChevronRightIcon,
  ChevronLeftIcon
} from "@chakra-ui/icons"


export function DataTable({ columns: userColumns, data, renderRowSubComponent }) {
  const route = useRouter()
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    page,

    // The rest of these things are super handy, too )
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
    visibleColumns,
    state: { expanded }
  } = useTable(
    {
      columns: userColumns,
      data,
      initialState: { pageIndex: 0, pageSize: 20 }
    },
    useExpanded // Use the useExpanded plugin hook
    , usePagination
  )

  const isOdd = (rowId) => {
    let id = 0
    const pos = rowId.lastIndexOf(".")
    if (pos === -1) {
      id = parseInt(rowId, 10)
    } else {
      id = parseInt(rowId.substr(pos + 1), 10)
    }
    return (id + 1) % 2 ? true : false
  }

  return (
    <Box>
      <Container maxW="container.xl">
        <Card minH="83px" p={0}>
          <CardBody overflow="auto">
            <Flex display="flex" direction="column" w="100%">
              <Table className={styles.TableRowSpace} justifyContent="center" alignItems="center" borderRadius="10px" overflow="hidden" {...getTableProps()}>
                <Thead>
                  {headerGroups.map((headerGroup, headerGroupIndex) => (
                    <Tr {...headerGroup.getHeaderGroupProps()} key={headerGroupIndex}>
                      {headerGroup.headers.map((column, columnIndex) => (
                        <Th
                        key={columnIndex}
                        verticalAlign="baseline"
                        whiteSpace="initial"
                        overflow= "hidden"
                        textOverflow="ellipsis"
                          {...column.getHeaderProps()}
                          fontSize={{ base: "13px", md: "13px", lg: "16px", xl:"16px" }}
                          m={0}
                          p={"1.2rem 0.5rem"}
                          fontWeight="600"
                          bg="#d5e3ff"
                        >
                          {column.render("Header")}
                        </Th>
                      ))}
                    </Tr>
                  ))}
                </Thead>
                {(page.length > 0 &&
                  <Tbody {...getTableBodyProps()}>
                    {page.map((row, i) => {
                      prepareRow(row)
                      return (
                        // Use a React.Fragment here so the table markup is still valid
                        <React.Fragment key={i}>
                          <Tr transition="all .5s ease-in-out" bg="#fff" w="100%"  {...row.getRowProps()} _hover={{
                            background: "rgba(213, 227, 255,0.2)"
                          }}
                          >
                            {row.cells.map((cell, cellIndex) => {
                              return (
                                <Td
                                key={cellIndex}
                                maxWidth="50px"
                                width= "60px"
                                overflow= "hidden"
                                fontSize={{ base: "14px", md: "14px", lg: "16px", xl:"16px" }}
                                textOverflow="ellipsis" whiteSpace="nowrap" fontWeight="400" color="#243e63" p={".81rem 0.5rem"} {...cell.getCellProps()}>
                                  {
                                    cell?.column?.Header == "Rating"
                                      ? <Box
                                        bg="transparent"
                                        fontSize="16px"
                                        color="#718096"
                                        letterSpacing="-1px"
                                      >
                                        {cell.render("Cell")}
                                      </Box>
                                      : cell.render("Cell")
                                  }
                                </Td>
                              )
                            })}
                          </Tr>
                          {/*
                                                    If the row is in an expanded state, render a row with a
                                                    column that fills the entire length of the table.
                                                */}
                          {row.isExpanded ? (
                            <Tr>
                              <Td bg="#fff" fontSize="1rem" p={"0rem"} colSpan={visibleColumns.length}>
                                {/*
                                                                Inside it, call our renderRowSubComponent function.
                                                            */}
                                {renderRowSubComponent({ row })}
                              </Td>
                            </Tr>
                          ) : null}
                        </React.Fragment>
                      )
                    })}
                  </Tbody>
                ) || <Tbody><Tr><Td textAlign="center" colSpan="5">No records available</Td></Tr></Tbody>}
              </Table>
              {
                page.length > 0  ?
                  <Flex justifyContent="space-between" m={4} alignItems="center">
                    <Flex>
                      <Tooltip label="First Page">
                        <IconButton
                          onClick={() => gotoPage(0)}
                          isDisabled={!canPreviousPage}
                          icon={<ArrowLeftIcon h={3} w={3} />}
                          mr={4}
                        />
                      </Tooltip>
                      <Tooltip label="Previous Page">
                        <IconButton
                          onClick={previousPage}
                          isDisabled={!canPreviousPage}
                          icon={<ChevronLeftIcon h={6} w={6} />}
                        />
                      </Tooltip>
                    </Flex>
                    <Flex alignItems="center" direction={{sm:"column", md:"column", lg:"row"}}>
                      <Text flexShrink="0" mr={{base:"0px", sm:"0px", md:"15px", lg:"15px"}} mb={{base:"15px", sm:"15px", md:"0px", lg:"0px"}}>
                        Page{" "}
                        <Text fontWeight="bold" as="span">
                          {pageIndex + 1}
                        </Text>{" "}
                        of{" "}
                        <Text fontWeight="bold" as="span">
                          {pageOptions.length}
                        </Text>
                      </Text>
                      <Text flexShrink="0">Go to page:</Text>{" "}
                      <NumberInput
                         mr={{base:"0px", sm:"0px", md:"15px", lg:"15px"}} mb={{base:"0px", sm:"0px", md:"0px", lg:"0px"}}
                        w={28}
                        min={1}
                        max={pageOptions.length}
                        onChange={(value) => {
                          const page = value ? value - 1 : 0
                          gotoPage(page)
                        }}
                        defaultValue={pageIndex + 1}
                      >
                        <NumberInputField />
                        <NumberInputStepper>
                          <NumberIncrementStepper />
                          <NumberDecrementStepper />
                        </NumberInputStepper>
                      </NumberInput>
                      <Select
                       mt={{base:"15px", sm:"15px", md:"0px", lg:"0px"}}
                        w={{base:"100%", sm:"100%", md:"120px", lg:"120px"}}
                        value={pageSize}
                        onChange={(e) => {
                          setPageSize(Number(e.target.value))
                        }}
                      >
                        {[10, 20, 30, 40, 50].map((pageSize) => (
                          <option key={pageSize} value={pageSize}>
                            Show {pageSize}
                          </option>
                        ))}
                      </Select>
                    </Flex>
                    <Flex>
                      <Tooltip label="Next Page">
                        <IconButton
                          onClick={nextPage}
                          isDisabled={!canNextPage}
                          icon={<ChevronRightIcon h={6} w={6} />}
                        />
                      </Tooltip>
                      <Tooltip label="Last Page">
                        <IconButton
                          onClick={() => gotoPage(pageCount - 1)}
                          isDisabled={!canNextPage}
                          icon={<ArrowRightIcon h={3} w={3} />}
                          ml={4}
                        />
                      </Tooltip>
                    </Flex>
                  </Flex>
                  : null
              }
            </Flex>
          </CardBody>
        </Card>
      </Container>
    </Box>
  )
}
